/** See `src/i18n/locales/en/managePilots.ts`. */
export const managePilots = {
  page: {
    title: 'Piloten',
    lead: 'Alle Piloten auf der Plattform, filterbar nach Unternehmen und Status.',
    filterCompany: 'Unternehmen',
    filterStatus: 'Status',
    allCompanies: 'Alle Unternehmen',
    allStatuses: 'Alle Status',
    empty: 'Keine Piloten entsprechen diesen Filtern.',
    rowsLabel: 'die Piloten',
    company: 'Unternehmen',
    name: 'Name',
    status: 'Status',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    departments: 'Abteilungen',
  },
  status: {
    draft: 'Entwurf',
    baseline: 'Nullmessung',
    active: 'Aktiv',
    interim_review: 'Zwischenevaluation',
    final_review: 'Abschlussevaluation',
    completed: 'Abgeschlossen',
    scaled: 'Skaliert',
  },
} as const;
